module.exports = __webpack_public_path__ + "static/geotief-folder-cedd2967634553726ed4c4561c13d37d.pdf";